<pbl-ngrid
  [dataSource]="dataSource"
  [columns]="columns"
  style="height: 250px"
  class="inspector-table pbl-ngrid-cell-ellipsis"
  noFiller
  matSort
  [matSortDisableClear]="true"
  matSortActive="Date"
  [blockUi]="!(tableData$ | async)"
  matSortDirection="desc"
  vScrollNone
  detailRow
  [singleDetailRow]="true"
  whenContextChange="close"
  [rowClassUpdate]="evenRowClassUpdate"
  (toggleChange)="detailRowClicked($event)">
  <ng-content select="#ngrid-definitions"></ng-content>
  <div *pblNgridDetailRowDef="let row; rowContext as rowContext;" class="pbl-detail-row" [ngClass]="{'even-row-index': rowContext.dsIndex%2 === 0}">
    <ng-container [ngTemplateOutlet]="detailRow" [ngTemplateOutletContext]="{row : row}"></ng-container>
  </div>
  <div *pblNgridCellDef="'_arrow_'; row as row">
    <mat-icon class="row-detail-icon-button" [ngClass]="{'open-detail-row': isDetailRowOpen && row.id === selectedFile.id}">
      {{ isDetailRowOpen && row.id === selectedFile.id ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </div>
</pbl-ngrid>
<ng-template #detailRow let-row="row">
  <div class="file-details-header-container">
    <sg-button (onClick)="onClickDownloadFile.emit(selectedFile.id)" variant="secondary" size="medium" text="Download" icon="download"></sg-button>
    <ng-content select="#file-details-container"></ng-content>
  </div>
  @if ({ content: selectedFileContent$ | async }; as file) {
  <div class="file-content-container">
    @if (!(isLoading$ | async)) {
    <pre class="file-content"><sg-text class="swift-pre-text" variant="sg-p2">{{file.content}}</sg-text></pre>
    } @else {
    <mat-spinner diameter="30" class="detail-spinner"></mat-spinner>
    }
  </div>
  }
</ng-template>
